import jwt_decode from "jwt-decode";

export default function WhoAmI() {
    // read token from storage and decode it
    const token = localStorage.getItem("token");
    if (!token) return null;
    const decodedToken = jwt_decode(token);
    return decodedToken;
};